import * as i2 from '@angular/common';
import { CommonModule, Location } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, inject, DestroyRef, Output, ViewChild, Pipe } from '@angular/core';
import * as i1 from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { ComponentsGlobalWebModule, IconComponent, ModalComponent, FormattedDatePipe, FeatureFlyGarmin } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i2$1 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScopeService, Scope } from '@garmin-avcloud/avcloud-fly-web-common/admin-authorization';
import { GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN, SKU_SERVICE_TOKEN, SUBSCRIPTIONS_SERVICE_TOKEN, GarminPilotSubscriptionsService, SUBSCRIPTIONS_JOB_MANAGEMENT_TOKEN, MOBILE_DEVICE_SERVICE_TOKEN, isGarminPilotSubscription } from '@garmin-avcloud/avcloud-fly-web-common/api';
import { RouterModule, ActivatedRoute, Router } from '@angular/router';
import { FLY_WEB_COMMON_CONFIG } from '@garmin-avcloud/avcloud-fly-web-common/config';
import { FeaturesService } from '@garmin-avcloud/avcloud-web-utils/feature';
import { switchMap, map, concatMap, forkJoin, of, combineLatest, take, iif, BehaviorSubject, filter, skipWhile, tap, combineLatestWith } from 'rxjs';
function CoverageDetailsMobileDeviceComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 2);
  }
}
function CoverageDetailsMobileDeviceComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 3);
  }
}
function CoverageDetailsMobileDeviceComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "strong");
    i0.ɵɵtext(2, "Available on:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 1);
    i0.ɵɵtemplate(4, CoverageDetailsMobileDeviceComponent_Conditional_0_Conditional_4_Template, 1, 0, "fly-icon", 2)(5, CoverageDetailsMobileDeviceComponent_Conditional_0_Conditional_5_Template, 1, 0, "fly-icon", 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.iosSupported ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.androidSupported ? 5 : -1);
  }
}
function CoverageDetailsMobileDeviceComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em");
    i0.ɵɵtext(1, "Apple is a trademark of Apple Inc.");
    i0.ɵɵelementEnd();
  }
}
function CoverageDetailsMobileDeviceComponent_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "em");
    i0.ɵɵtext(1, "Android is a trademark of Google LLC");
    i0.ɵɵelementEnd();
  }
}
function CoverageDetailsMobileDeviceComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "h4");
    i0.ɵɵtext(2, "Overview");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 4);
    i0.ɵɵtemplate(4, CoverageDetailsMobileDeviceComponent_Conditional_1_Conditional_4_Template, 2, 0, "em");
    i0.ɵɵelement(5, "br");
    i0.ɵɵtemplate(6, CoverageDetailsMobileDeviceComponent_Conditional_1_Conditional_6_Template, 2, 0, "em");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", ctx_r0.detailsHTML, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.iosSupported ? 4 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.androidSupported ? 6 : -1);
  }
}
const _c0 = () => ({
  text: "Cancel",
  action: "close"
});
const _c1 = a0 => ({
  text: "Delete Device",
  action: a0,
  primary: true
});
const _c2 = (a0, a1) => [a0, a1];
function ManageMobileDeviceComponent_Conditional_0_Conditional_9_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 18);
    i0.ɵɵlistener("click", function ManageMobileDeviceComponent_Conditional_0_Conditional_9_Conditional_3_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.updateDeviceRegistration());
    });
    i0.ɵɵtext(1, " Save Changes ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r2.actionsDisabled);
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "g-button", 16);
    i0.ɵɵlistener("click", function ManageMobileDeviceComponent_Conditional_0_Conditional_9_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.newDeviceName.setValue(ctx_r2.deviceRegistration.gpDeviceName));
    });
    i0.ɵɵtext(2, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ManageMobileDeviceComponent_Conditional_0_Conditional_9_Conditional_3_Template, 2, 1, "g-button", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.actionsDisabled);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.newDeviceName.untouched || ctx_r2.newDeviceName.dirty ? 3 : -1);
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r2.updateMsg.success ? "success-msg" : "error-msg");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.updateMsg.message, " ");
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 11);
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 12);
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.deviceRegistration.gpDeviceCode, " ");
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " Show Device ID ");
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 19);
    i0.ɵɵlistener("click", function ManageMobileDeviceComponent_Conditional_0_Conditional_25_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      i0.ɵɵnextContext(2);
      const modal_r6 = i0.ɵɵreference(2);
      return i0.ɵɵresetView(modal_r6.open());
    });
    i0.ɵɵtext(1, " Delete Device ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r2.actionsDisabled);
  }
}
function ManageMobileDeviceComponent_Conditional_0_Conditional_27_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.deleteErrorMessage, " ");
  }
}
function ManageMobileDeviceComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "h1");
    i0.ɵɵtext(2, "Manage Mobile Device");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2)(4, "div", 3)(5, "label", 4);
    i0.ɵɵtext(6, " Name: ");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "input", 5);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵtemplate(9, ManageMobileDeviceComponent_Conditional_0_Conditional_9_Template, 4, 2, "div", 6);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵtemplate(11, ManageMobileDeviceComponent_Conditional_0_Conditional_11_Template, 2, 2, "span", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 8)(13, "span", 9);
    i0.ɵɵtext(14, "Platform:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "span", 10);
    i0.ɵɵtemplate(16, ManageMobileDeviceComponent_Conditional_0_Conditional_16_Template, 1, 0, "fly-icon", 11)(17, ManageMobileDeviceComponent_Conditional_0_Conditional_17_Template, 1, 0, "fly-icon", 12);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(19, "div", 8)(20, "span", 9);
    i0.ɵɵtext(21, "ID:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "button", 13);
    i0.ɵɵlistener("click", function ManageMobileDeviceComponent_Conditional_0_Template_button_click_22_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.showDeviceId = !ctx_r2.showDeviceId);
    });
    i0.ɵɵtemplate(23, ManageMobileDeviceComponent_Conditional_0_Conditional_23_Template, 1, 1)(24, ManageMobileDeviceComponent_Conditional_0_Conditional_24_Template, 1, 0);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(25, ManageMobileDeviceComponent_Conditional_0_Conditional_25_Template, 2, 1, "g-button", 14);
    i0.ɵɵpipe(26, "async");
    i0.ɵɵtemplate(27, ManageMobileDeviceComponent_Conditional_0_Conditional_27_Template, 2, 1, "p", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("disabled", ctx_r2.actionsDisabled || i0.ɵɵpipeBind1(8, 10, ctx_r2.canEdit$) === false)("formControl", ctx_r2.newDeviceName);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(10, 12, ctx_r2.canEdit$) ? 9 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.updateMsg != null && !ctx_r2.newDeviceName.dirty ? 11 : -1);
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r2.deviceRegistration.gpDevicePlatform === "iOS" ? 16 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.deviceRegistration.gpDevicePlatform === "Android" ? 17 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r2.deviceRegistration.gpDevicePlatform, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r2.showDeviceId ? 23 : 24);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(26, 14, ctx_r2.canDelete$) ? 25 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.deleteErrorMessage != null ? 27 : -1);
  }
}
function MobileDeviceCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.uniqueId);
  }
}
function MobileDeviceCardComponent_Conditional_5_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 5);
  }
}
function MobileDeviceCardComponent_Conditional_5_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 6);
  }
}
function MobileDeviceCardComponent_Conditional_5_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 7);
  }
}
function MobileDeviceCardComponent_Conditional_5_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("apple-icon", ctx_r0.devicePlatform === "iOS");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.devicePlatform, " ");
  }
}
function MobileDeviceCardComponent_Conditional_5_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "Mobile Device");
    i0.ɵɵelementEnd();
  }
}
function MobileDeviceCardComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, MobileDeviceCardComponent_Conditional_5_Case_1_Template, 1, 0, "fly-icon", 5)(2, MobileDeviceCardComponent_Conditional_5_Case_2_Template, 1, 0, "fly-icon", 6)(3, MobileDeviceCardComponent_Conditional_5_Case_3_Template, 1, 0, "fly-icon", 7)(4, MobileDeviceCardComponent_Conditional_5_Conditional_4_Template, 2, 3, "span", 8)(5, MobileDeviceCardComponent_Conditional_5_Conditional_5_Template, 2, 0, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_1_0 = ctx_r0.devicePlatform) === "iOS" ? 1 : tmp_1_0 === "Android" ? 2 : tmp_1_0 === "Other" ? 3 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.devicePlatform === "iOS" || ctx_r0.devicePlatform === "Android" ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.devicePlatform === "Other" ? 5 : -1);
  }
}
function MobileDeviceCardComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 9);
    i0.ɵɵlistener("click", function MobileDeviceCardComponent_Conditional_6_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.actionClicked.emit());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.action, " ");
  }
}
function PromoCodeCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Supports Up to ", ctx_r0.devices, " devices.");
  }
}
function PromoCodeCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 4);
    i0.ɵɵtext(2, "Expiration:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "flyFormattedDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, ctx_r0.expiryCalc), " (estimated) ");
  }
}
function PromoCodeCardComponent_Conditional_4_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 7);
  }
}
function PromoCodeCardComponent_Conditional_4_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-icon", 8);
  }
}
function PromoCodeCardComponent_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-coverage-details-mobile-device", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("detailsHTML", ctx_r0.detailsHTML)("supportedPlatforms", ctx_r0.supportedPlatforms);
  }
}
function PromoCodeCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "g-button", 5);
    i0.ɵɵlistener("click", function PromoCodeCardComponent_Conditional_4_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.toggleDetails());
    });
    i0.ɵɵelementStart(2, "span", 6);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, PromoCodeCardComponent_Conditional_4_Conditional_4_Template, 1, 0, "fly-icon", 7)(5, PromoCodeCardComponent_Conditional_4_Conditional_5_Template, 1, 0, "fly-icon", 8);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(6, PromoCodeCardComponent_Conditional_4_Conditional_6_Template, 1, 2, "fly-coverage-details-mobile-device", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("flat", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.detailsExpanded ? "Hide" : "View", " Details ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.detailsExpanded ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.detailsExpanded ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.detailsExpanded ? 6 : -1);
  }
}
function PromoCodeCardComponent_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div");
  }
}
function PromoCodeCardComponent_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1, "START NEW SUBSCRIPTION");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeCardComponent_Conditional_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtext(1, "EXTENDING SUBSCRIPTION");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeCardComponent_Conditional_7_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 12);
    i0.ɵɵlistener("click", function PromoCodeCardComponent_Conditional_7_Conditional_3_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.clickMakeChoice());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.selected != null ? "Change" : "Make", " Selection ");
  }
}
function PromoCodeCardComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, PromoCodeCardComponent_Conditional_7_Conditional_1_Template, 2, 0, "div", 10)(2, PromoCodeCardComponent_Conditional_7_Conditional_2_Template, 2, 0, "div", 10)(3, PromoCodeCardComponent_Conditional_7_Conditional_3_Template, 2, 1, "g-button", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selected != null && ctx_r0.selected === "" ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.selected != null && ctx_r0.selected !== "" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.choices != null && ctx_r0.choices.length !== 0 ? 3 : -1);
  }
}
function PromoCodeChoiceCardComponent_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("Covers up to ", ctx_r0.slotDetails.totalSlots, " devices");
  }
}
function PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " , ");
  }
}
function PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_For_3_Conditional_0_Template, 1, 0);
    i0.ɵɵtext(1);
  }
  if (rf & 2) {
    const device_r2 = ctx.$implicit;
    const ɵ$index_15_r3 = ctx.$index;
    i0.ɵɵconditional(ɵ$index_15_r3 > 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", device_r2, " ");
  }
}
function PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtext(1, " Covered Devices: ");
    i0.ɵɵrepeaterCreate(2, PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_For_3_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r0.slotDetails.claimedSlotDevices);
  }
}
function PromoCodeChoiceCardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, PromoCodeChoiceCardComponent_Conditional_3_Conditional_0_Template, 2, 1, "div", 1)(1, PromoCodeChoiceCardComponent_Conditional_3_Conditional_1_Template, 4, 0, "div", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.slotDetails.totalSlots != null && ctx_r0.slotDetails.totalSlots > 1 && (ctx_r0.slotDetails.claimedSlotDevices == null || ctx_r0.slotDetails.claimedSlotDevices.length === 0) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.slotDetails.totalSlots > 1 && ctx_r0.slotDetails.claimedSlotDevices != null && ctx_r0.slotDetails.claimedSlotDevices.length > 0 ? 1 : -1);
  }
}
function PromoCodeChoiceCardComponent_Conditional_4_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, "Expiration if Extended:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "flyFormattedDate");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, ctx_r0.expiryCalc), " (estimated) ");
  }
}
function PromoCodeChoiceCardComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 5);
    i0.ɵɵtext(2, "Current Expiration:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "flyFormattedDate");
    i0.ɵɵelement(5, "br");
    i0.ɵɵtemplate(6, PromoCodeChoiceCardComponent_Conditional_4_Conditional_6_Template, 4, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, ctx_r0.subscription.authorization.activeEndDate), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.expiryCalc != null ? 6 : -1);
  }
}
function PromoCodeChoiceCardComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "span", 5);
    i0.ɵɵtext(2, "Expiration:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "flyFormattedDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, ctx_r0.expiryCalc), " (estimated) ");
  }
}
function PromoCodeChoiceCardComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1, "CURRENTLY SELECTED");
    i0.ɵɵelementEnd();
  }
}
const _forTrack0 = ($index, $item) => $item.sku;
const _forTrack1 = ($index, $item) => $item.subscriptionUuid;
function PromoCodeSubscriptionsListComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 0);
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "No Products found for this Promo Code.");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "No Products affected by this Promo Code.");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_3_For_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-promo-code-card", 2);
    i0.ɵɵlistener("makeChoice", function PromoCodeSubscriptionsListComponent_Conditional_3_For_1_Template_fly_promo_code_card_makeChoice_0_listener() {
      const product_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.makeChoice(product_r2));
    })("manageDevices", function PromoCodeSubscriptionsListComponent_Conditional_3_For_1_Template_fly_promo_code_card_manageDevices_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.manageDevices.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const product_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", product_r2.display)("duration", product_r2.duration)("redeemed", ctx_r2.redeemed)("uuid", product_r2.sku)("selected", ctx_r2.selectedChoicesUuid.get(product_r2.sku))("choices", ctx_r2.skuToChoices.get(product_r2.sku))("detailsHTML", product_r2.coverageDescriptionHTML)("supportedPlatforms", product_r2.supportedPlatforms);
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, PromoCodeSubscriptionsListComponent_Conditional_3_For_1_Template, 1, 8, "fly-promo-code-card", 1, _forTrack0);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.promoCodeSkuProducts);
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_4_For_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-promo-code-choice-card", 7);
    i0.ɵɵlistener("selected", function PromoCodeSubscriptionsListComponent_Conditional_4_For_5_Template_fly_promo_code_choice_card_selected_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.makeSelection(ctx_r2.currentlySelectingProduct, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const subscription_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("duration", ctx_r2.currentlySelectingProduct.duration)("subscription", subscription_r6)("existing", ctx_r2.currentlySelectingExisting === subscription_r6.subscriptionUuid);
  }
}
function PromoCodeSubscriptionsListComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵtext(0, " The below selection has an active subscription. You may choose to extend the existing subscription, or start a new subscription that runs concurrently. ");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "fly-promo-code-choice-card", 4);
    i0.ɵɵlistener("selected", function PromoCodeSubscriptionsListComponent_Conditional_4_Template_fly_promo_code_choice_card_selected_3_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.makeSelection(ctx_r2.currentlySelectingProduct, $event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(4, PromoCodeSubscriptionsListComponent_Conditional_4_For_5_Template, 1, 3, "fly-promo-code-choice-card", 5, _forTrack1);
    i0.ɵɵelementStart(6, "g-button", 6);
    i0.ɵɵlistener("click", function PromoCodeSubscriptionsListComponent_Conditional_4_Template_g_button_click_6_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.clearChoosing());
    });
    i0.ɵɵtext(7, " Back ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r2.currentlySelectingProduct.display, " \u2014 ", ctx_r2.currentlySelectingProduct.duration, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("duration", ctx_r2.currentlySelectingProduct.duration)("existing", ctx_r2.currentlySelectingExisting === "");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.currentlySelectingSubscription);
  }
}
function PromoCodeWizardComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error");
    i0.ɵɵtext(1, " Promo Code cannot be blank. ");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeWizardComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-error", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.promoResponseError, i0.ɵɵsanitizeHtml);
  }
}
function PromoCodeWizardComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "g-input", 2);
    i0.ɵɵelement(2, "input", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 4)(4, "g-button", 5);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_0_Template_g_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.checkPromoCode());
    });
    i0.ɵɵtext(5, " Redeem ");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, PromoCodeWizardComponent_Conditional_0_Conditional_6_Template, 2, 0, "g-error")(7, PromoCodeWizardComponent_Conditional_0_Conditional_7_Template, 1, 1, "g-error", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControl", ctx_r1.promoCodeInput);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r1.promoCodeInput.value == null || ctx_r1.promoCodeInput.value.length === 0 || ctx_r1.loading);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((ctx_r1.promoCodeInput.touched || ctx_r1.promoCodeInput.dirty) && (ctx_r1.promoCodeInput.errors == null ? null : ctx_r1.promoCodeInput.errors["required"]) != null ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.promoResponseError.length > 0 ? 7 : -1);
  }
}
function PromoCodeWizardComponent_Conditional_1_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-radio", 9);
    i0.ɵɵelement(1, "input", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const code_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("label", code_r4.subsetName);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.promoCodeRadio)("value", code_r4);
  }
}
function PromoCodeWizardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1, " This promo code is valid for several regions listed below. Please select a region, and press \"CONTINUE\". ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 8);
    i0.ɵɵrepeaterCreate(3, PromoCodeWizardComponent_Conditional_1_For_4_Template, 2, 3, "g-radio", 9, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 10)(6, "g-button", 11);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_1_Template_g_button_click_6_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.resetToEnter());
    });
    i0.ɵɵtext(7, " Cancel ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "g-button", 12);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_1_Template_g_button_click_8_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectPromoCode());
    });
    i0.ɵɵtext(9, " Continue ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.promoCodeSubsets);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("disabled", ctx_r1.promoCodeRadio.value == null);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1, " Your new subscriptions are being activated! Please wait a few moments for the subscriptions to appear under \"Active Subscriptions.\" ");
    i0.ɵɵelementEnd();
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-error", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r1.promoResponseError, i0.ɵɵsanitizeHtml);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-input", 16);
    i0.ɵɵelement(1, "input", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r1.reasonInput);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 20);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_2_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.resetToEnter());
    });
    i0.ɵɵtext(1, " Cancel ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r1.loading);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "g-button", 20);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_3_Template_g_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.resetToSelect());
    });
    i0.ɵɵtext(1, " Back ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r1.loading);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_0_Template, 2, 1, "g-input", 16);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵtemplate(2, PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_2_Template, 2, 1, "g-button", 18)(3, PromoCodeWizardComponent_Conditional_2_Conditional_3_Conditional_3_Template, 2, 1, "g-button", 18);
    i0.ɵɵelementStart(4, "g-button", 12);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_2_Conditional_3_Template_g_button_click_4_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.redeemPromoCode());
    });
    i0.ɵɵtext(5, " Redeem ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.showReasonInputTextBox ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!(ctx_r1.promoCodeSubsets.length > 1) ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.promoCodeSubsets.length > 1 ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.showReasonInputTextBox && ctx_r1.reasonInput.value == null || ctx_r1.loading || ctx_r1.usersSelections == null);
  }
}
function PromoCodeWizardComponent_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "g-button", 21);
    i0.ɵɵlistener("click", function PromoCodeWizardComponent_Conditional_2_Conditional_4_Template_g_button_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.navigateToActiveSubscriptions());
    });
    i0.ɵɵtext(2, " Done ");
    i0.ɵɵelementEnd()();
  }
}
function PromoCodeWizardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, PromoCodeWizardComponent_Conditional_2_Conditional_0_Template, 2, 0, "div", 14);
    i0.ɵɵelementStart(1, "fly-promo-code-subscriptions-list", 15);
    i0.ɵɵlistener("editing", function PromoCodeWizardComponent_Conditional_2_Template_fly_promo_code_subscriptions_list_editing_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editingMode($event));
    })("userSelection", function PromoCodeWizardComponent_Conditional_2_Template_fly_promo_code_subscriptions_list_userSelection_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.fullSelection($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, PromoCodeWizardComponent_Conditional_2_Conditional_2_Template, 1, 1, "g-error", 6)(3, PromoCodeWizardComponent_Conditional_2_Conditional_3_Template, 6, 4)(4, PromoCodeWizardComponent_Conditional_2_Conditional_4_Template, 3, 0, "div");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.redeemed ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("promoCodeData", ctx_r1.promoCodeSelection)("activeSubscriptions", ctx_r1.existingSubscriptions)("redeemed", ctx_r1.redeemed);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.promoResponseError.length > 0 ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.redeemed && ctx_r1.promoCodeResponse != null && !ctx_r1.editing ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.redeemed ? 4 : -1);
  }
}
function PromoCodeWizardComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader", 0);
  }
}
const _forTrack2 = ($index, $item) => $item.uuid;
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_13_0;
    const device_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", device_r3.uuid);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", (tmp_13_0 = device_r3.gpDeviceName) !== null && tmp_13_0 !== undefined ? tmp_13_0 : device_r3.gpDeviceCode, " ");
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "g-error", 5);
    i0.ɵɵtext(1, " There was an error attempting to claim the subscription slot. ");
    i0.ɵɵelementEnd();
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "g-drop-down", 2)(2, "select", 3);
    i0.ɵɵtwoWayListener("ngModelChange", function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Template_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectedDeviceUuid, $event) || (ctx_r1.selectedDeviceUuid = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵrepeaterCreate(3, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_For_4_Template, 2, 2, "option", 4, _forTrack2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Conditional_5_Template, 2, 0, "g-error", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "g-button", 6);
    i0.ɵɵlistener("click", function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Template_g_button_click_6_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.addDeviceToSlot());
    });
    i0.ɵɵtext(7, " Add ");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectedDeviceUuid);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.devices);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.spotClaimingError ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r1.selectedDeviceUuid == null);
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " In order to add your device to this Add-On subscription, it must be associated with a base Garmin Pilot Subscription. ");
    i0.ɵɵelementEnd();
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " You do not currently have any devices to add to this subscription. In order to add a device to this subscription, please login to Garmin Pilot on your phone or tablet. ");
    i0.ɵɵelementEnd();
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Conditional_0_Template, 2, 0, "p");
    i0.ɵɵpipe(1, "flyGpSubscriptionType");
    i0.ɵɵtemplate(2, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Conditional_2_Template, 2, 0, "p");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r1.subscription) === "ADD-ON" ? 0 : 2);
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_0_Template, 8, 3)(1, AddMobileDeviceToSlotCardComponent_Conditional_1_Conditional_1_Template, 3, 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.devices.length > 0 ? 0 : 1);
  }
}
function AddMobileDeviceToSlotCardComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 1);
    i0.ɵɵtext(1, "There was an error retrieving devices to add to this subscription. Please try again later.");
    i0.ɵɵelementEnd();
  }
}
function SlotManagementPageComponent_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "g-loader");
  }
}
function SlotManagementPageComponent_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 1);
    i0.ɵɵtext(1, " Unable to retrieve subscription due to no subscriptionUuid in the URL. ");
    i0.ɵɵelementEnd();
  }
}
function SlotManagementPageComponent_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 1);
    i0.ɵɵtext(1, "Unable to retrieve details for this subscription.");
    i0.ɵɵelementEnd();
  }
}
function SlotManagementPageComponent_Case_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "b");
    i0.ɵɵtext(2, "Effective Date:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "flyFormattedDate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, ctx_r0.subscription.authorization.effectiveDate, "FullDate"), "");
  }
}
function SlotManagementPageComponent_Case_5_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p")(1, "b");
    i0.ɵɵtext(2, "Billing Account:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.subscription.billingAccountId, "");
  }
}
function SlotManagementPageComponent_Case_5_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.deviceRegistrations.length, " / ", ctx_r0.subscription.gpSubscriptions.slotDetails.totalSlots, " Slot(s) Assigned ");
  }
}
function SlotManagementPageComponent_Case_5_For_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-mobile-device-card", 4);
    i0.ɵɵpipe(1, "flyDevicePlatform");
    i0.ɵɵlistener("actionClicked", function SlotManagementPageComponent_Case_5_For_14_Template_fly_mobile_device_card_actionClicked_0_listener() {
      const device_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleRemoveActionClicked(device_r3));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_11_0;
    const device_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("name", (tmp_11_0 = device_r3.gpDeviceName) !== null && tmp_11_0 !== undefined ? tmp_11_0 : "Unknown Device")("site", ctx_r0.siteConfig.site)("uniqueId", device_r3.gpDeviceCode)("devicePlatform", i0.ɵɵpipeBind1(1, 4, device_r3));
  }
}
function SlotManagementPageComponent_Case_5_Conditional_15_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fly-add-mobile-device-to-slot-card", 6);
    i0.ɵɵlistener("deviceAdded", function SlotManagementPageComponent_Case_5_Conditional_15_Conditional_0_Template_fly_add_mobile_device_to_slot_card_deviceAdded_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.refreshSignal$.next());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("subscription", ctx_r0.subscription);
  }
}
function SlotManagementPageComponent_Case_5_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, SlotManagementPageComponent_Case_5_Conditional_15_Conditional_0_Template, 1, 1, "fly-add-mobile-device-to-slot-card", 5);
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.deviceRegistrations.length < ((tmp_2_0 = ctx_r0.subscription.gpSubscriptions == null ? null : ctx_r0.subscription.gpSubscriptions.slotDetails == null ? null : ctx_r0.subscription.gpSubscriptions.slotDetails.totalSlots) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 0) ? 0 : -1);
  }
}
function SlotManagementPageComponent_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, SlotManagementPageComponent_Case_5_Conditional_2_Template, 5, 4, "p");
    i0.ɵɵelementStart(3, "p")(4, "b");
    i0.ɵɵtext(5, "Expiration Date:");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "flyFormattedDate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, SlotManagementPageComponent_Case_5_Conditional_8_Template, 4, 1, "p");
    i0.ɵɵelementStart(9, "div", 2)(10, "h3");
    i0.ɵɵtext(11, "Mobile Devices");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, SlotManagementPageComponent_Case_5_Conditional_12_Template, 2, 2, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(13, SlotManagementPageComponent_Case_5_For_14_Template, 2, 6, "fly-mobile-device-card", 3, _forTrack2);
    i0.ɵɵtemplate(15, SlotManagementPageComponent_Case_5_Conditional_15_Template, 1, 1);
    i0.ɵɵpipe(16, "async");
  }
  if (rf & 2) {
    let tmp_1_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate((tmp_1_0 = ctx_r0.subscription.shortName) !== null && tmp_1_0 !== undefined ? tmp_1_0 : ctx_r0.subscription.description);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.siteConfig.site === "FALA" ? 2 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(7, 6, ctx_r0.subscription.authorization.activeEndDate, "FullDate"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.siteConfig.site === "FALA" ? 8 : -1);
    i0.ɵɵadvance(4);
    i0.ɵɵconditional(ctx_r0.subscription.gpSubscriptions != null ? 12 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.deviceRegistrations);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(16, 9, ctx_r0.canClaimSlot$) ? 15 : -1);
  }
}
let CoverageDetailsMobileDeviceComponent = /*#__PURE__*/(() => {
  class CoverageDetailsMobileDeviceComponent {
    constructor() {
      this.androidSupported = false;
      this.iosSupported = false;
    }
    ngOnInit() {
      this.androidSupported = this.supportedPlatforms?.includes('android') ?? false;
      this.iosSupported = this.supportedPlatforms?.includes('ios') ?? false;
    }
    static {
      this.ɵfac = function CoverageDetailsMobileDeviceComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoverageDetailsMobileDeviceComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CoverageDetailsMobileDeviceComponent,
        selectors: [["fly-coverage-details-mobile-device"]],
        inputs: {
          detailsHTML: "detailsHTML",
          supportedPlatforms: "supportedPlatforms"
        },
        decls: 2,
        vars: 2,
        consts: [[1, "platforms"], [1, "icon-container"], ["icon", "apple", 1, "icon", "size-standard", "color-black"], ["icon", "android", 1, "icon", "size-standard", "color-black"], [1, "details", 3, "innerHTML"]],
        template: function CoverageDetailsMobileDeviceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CoverageDetailsMobileDeviceComponent_Conditional_0_Template, 6, 2, "div", 0)(1, CoverageDetailsMobileDeviceComponent_Conditional_1_Template, 7, 3, "div");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.supportedPlatforms != null && ctx.supportedPlatforms.length > 0 ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.detailsHTML != null && ctx.detailsHTML.length > 0 ? 1 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, IconComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.platforms[_ngcontent-%COMP%]{display:flex;gap:.5rem;align-items:center}.icon-container[_ngcontent-%COMP%]{display:flex;gap:.75rem}.details[_ngcontent-%COMP%]{padding-bottom:1rem}em[_ngcontent-%COMP%]{font-style:italic}"]
      });
    }
  }
  return CoverageDetailsMobileDeviceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ManageMobileDeviceComponent = /*#__PURE__*/(() => {
  class ManageMobileDeviceComponent {
    constructor() {
      this.deviceDeleted = new EventEmitter();
      this.destroyRef = inject(DestroyRef);
      this.deviceRegistration = null;
      this.newDeviceName = new FormControl(undefined, {
        nonNullable: true
      });
      this.updateMsg = null;
      this.deleteErrorMessage = null;
      this.showDeviceId = false;
      this.actionsDisabled = false;
      this.deviceRegistrationService = inject(GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN);
      this.scopeService = inject(ScopeService);
      this.deleteDeviceRegistration = () => {
        this.modal.close();
        this.actionsDisabled = true;
        this.deviceRegistrationService.deleteGarminPilotDeviceRegistration(this.deviceRegistrationUuid).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
          next: () => this.deviceDeleted.emit(),
          error: () => {
            this.deleteErrorMessage = 'Unable to delete device. Please try again later.';
            this.actionsDisabled = false;
          }
        });
      };
    }
    ngOnInit() {
      this.canEdit$ = this.scopeService.determinePrivilege(Scope.GP_DEVICE_REGISTRATION_EDIT);
      this.canDelete$ = this.scopeService.determinePrivilege(Scope.GP_DEVICE_REGISTRATION_DELETE);
      this.deviceRegistrationService.getDeviceRegistrationByUuid(this.deviceRegistrationUuid).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: deviceRegistration => {
          this.deviceRegistration = deviceRegistration;
          this.newDeviceName.setValue(deviceRegistration.gpDeviceName);
        },
        error: () => {
          this.deviceRegistration = null;
          this.newDeviceName.setValue(undefined);
        }
      });
    }
    updateDeviceRegistration() {
      this.actionsDisabled = true;
      this.deviceRegistrationService.updateGarminPilotDeviceRegistration(this.deviceRegistrationUuid, {
        gpDeviceName: this.newDeviceName.value
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          if (this.deviceRegistration != null) {
            //Should never be false.
            this.deviceRegistration.gpDeviceName = this.newDeviceName.value;
          }
          this.updateMsg = {
            message: 'Changes saved.',
            success: true
          };
          this.actionsDisabled = false;
          this.newDeviceName.markAsPristine();
        },
        error: () => {
          this.updateMsg = {
            message: 'Unable to update device name. Please try again later.',
            success: false
          };
          this.actionsDisabled = false;
        }
      });
    }
    static {
      this.ɵfac = function ManageMobileDeviceComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ManageMobileDeviceComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ManageMobileDeviceComponent,
        selectors: [["fly-manage-mobile-device"]],
        viewQuery: function ManageMobileDeviceComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(ModalComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.modal = _t.first);
          }
        },
        inputs: {
          deviceRegistrationUuid: "deviceRegistrationUuid"
        },
        outputs: {
          deviceDeleted: "deviceDeleted"
        },
        decls: 5,
        vars: 8,
        consts: [["modal", ""], ["header", "Are you sure you want to delete this device?", 3, "buttons"], [1, "wrapper"], [1, "device-detail", "detail-property-flex"], ["for", "device-registration-name", 1, "detail-label"], ["id", "device-registration-name", "type", "text", 1, "device-registration-name", 3, "disabled", "formControl"], [1, "form-action-buttons"], [3, "ngClass"], [1, "device-detail"], [1, "detail-label"], [1, "detail-property-flex"], ["icon", "apple", 1, "icon", "size-standard", "color-black"], ["icon", "android", 1, "icon", "size-standard", "color-black"], [1, "link-themed-button", 3, "click"], ["theme", "light", 1, "upppercase", "non-detail", "g-button-auto-width", 3, "disabled"], [1, "error-msg", "non-detail"], ["theme", "light", 1, "uppercase", "action-button", "g-button-auto-width", 3, "click", "disabled"], ["theme", "dark", 1, "uppercase", "action-button", "g-button-auto-width", 3, "disabled"], ["theme", "dark", 1, "uppercase", "action-button", "g-button-auto-width", 3, "click", "disabled"], ["theme", "light", 1, "upppercase", "non-detail", "g-button-auto-width", 3, "click", "disabled"]],
        template: function ManageMobileDeviceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ManageMobileDeviceComponent_Conditional_0_Template, 28, 16, "div");
            i0.ɵɵelementStart(1, "fly-modal", 1, 0)(3, "p");
            i0.ɵɵtext(4, " Deleting this device will remove it from your account as well as unclaim any subscription slots alloted to this device. ");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.deviceRegistration != null ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("buttons", i0.ɵɵpureFunction2(5, _c2, i0.ɵɵpureFunction0(2, _c0), i0.ɵɵpureFunction1(3, _c1, ctx.deleteDeviceRegistration)));
          }
        },
        dependencies: [ComponentsGlobalWebModule, i1.GButton, CommonModule, i2.NgClass, i2.AsyncPipe, FormsModule, i2$1.DefaultValueAccessor, i2$1.NgControlStatus, IconComponent, ReactiveFormsModule, i2$1.FormControlDirective, ModalComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.uppercase[_ngcontent-%COMP%]{text-transform:uppercase}.wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:space-between;gap:.25rem}.device-detail[_ngcontent-%COMP%]{min-height:2.25rem;display:flex;align-items:center;gap:.5rem;flex-wrap:wrap}.device-detail[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex:auto 0 0}.detail-label[_ngcontent-%COMP%]{font-weight:700}.detail-property-flex[_ngcontent-%COMP%]{display:inline-flex;align-items:center;gap:.25rem}.device-registration-name[_ngcontent-%COMP%]{padding:.375rem .125rem;border:1px solid rgb(216.75,216.75,216.75);margin-right:.25rem}.form-action-buttons[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-evenly;gap:.25rem}.action-button[_ngcontent-%COMP%]{min-width:max-content}.non-detail[_ngcontent-%COMP%]{padding-top:.75rem}.link-themed-button[_ngcontent-%COMP%]{cursor:pointer;text-decoration:underline}.success-msg[_ngcontent-%COMP%]{color:#4bb450}.error-msg[_ngcontent-%COMP%]{color:#920000}"]
      });
    }
  }
  return ManageMobileDeviceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileDeviceCardComponent = /*#__PURE__*/(() => {
  class MobileDeviceCardComponent {
    constructor() {
      this.uniqueId = null;
      this.devicePlatform = null;
      this.actionClicked = new EventEmitter();
      this.scopeService = inject(ScopeService);
    }
    ngOnInit() {
      this.canRemoveDeviceFromSlot$ = this.scopeService.determinePrivilege(Scope.GP_SUBSCRIPTION_DEVICE_SLOT_DELETE);
    }
    static {
      this.ɵfac = function MobileDeviceCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileDeviceCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileDeviceCardComponent,
        selectors: [["fly-mobile-device-card"]],
        inputs: {
          name: "name",
          action: "action",
          site: "site",
          uniqueId: "uniqueId",
          devicePlatform: "devicePlatform"
        },
        outputs: {
          actionClicked: "actionClicked"
        },
        decls: 8,
        vars: 6,
        consts: [[1, "card-container"], [1, "device-name"], [1, "device-platform-info"], [1, "button"], [1, "device-id"], ["icon", "apple", 1, "icon", "size-standard", "color-black"], ["icon", "android", 1, "icon", "size-standard", "color-black"], ["icon", "mobile-device", 1, "icon", "size-standard", "color-black"], [3, "apple-icon"], [1, "button", 3, "click"]],
        template: function MobileDeviceCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div")(2, "div", 1);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, MobileDeviceCardComponent_Conditional_4_Template, 3, 1, "div")(5, MobileDeviceCardComponent_Conditional_5_Template, 6, 3, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, MobileDeviceCardComponent_Conditional_6_Template, 2, 1, "g-button", 3);
            i0.ɵɵpipe(7, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.name);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.site === "FALA" && ctx.uniqueId != null ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.site === "FGA" && ctx.devicePlatform != null ? 5 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(i0.ɵɵpipeBind1(7, 4, ctx.canRemoveDeviceFromSlot$) ? 6 : -1);
          }
        },
        dependencies: [CommonModule, i2.AsyncPipe, IconComponent, ComponentsGlobalWebModule, i1.GButton],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}.card-container[_ngcontent-%COMP%]{padding:1.5rem;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;gap:2rem}@media screen and (min-width: 1024px){.card-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between}}.device-name[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:700}.button[_ngcontent-%COMP%]{margin-top:1rem}.device-platform-info[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.25rem}.apple-icon[_ngcontent-%COMP%]{margin-top:.25rem}"]
      });
    }
  }
  return MobileDeviceCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromoCodeCardComponent = /*#__PURE__*/(() => {
  class PromoCodeCardComponent {
    constructor() {
      this.devices = 1;
      this.redeemed = false;
      this.uuid = null;
      this.makeChoice = new EventEmitter();
      this.manageDevices = new EventEmitter();
      this.detailsExpanded = false;
      this.expiryCalc = null;
    }
    ngOnInit() {
      if (this.expiry != null) {
        this.expiryCalc = this.expiry;
      } else if (this.duration != null && this.duration != '') {
        const durationSplit = this.duration.split(' ');
        if (durationSplit.length === 2) {
          const num = parseInt(durationSplit[0]);
          if (!isNaN(num)) {
            const unit = durationSplit[1].toLocaleLowerCase();
            if (unit.startsWith('month')) {
              this.expiryCalc = new Date();
              this.expiryCalc.setMonth(this.expiryCalc.getMonth() + num);
            } else if (unit.startsWith('year')) {
              this.expiryCalc = new Date();
              this.expiryCalc.setFullYear(this.expiryCalc.getFullYear() + num);
            }
          }
        }
      }
    }
    clickManageDevices() {
      this.manageDevices.emit(this.uuid);
    }
    clickMakeChoice() {
      this.makeChoice.emit();
    }
    toggleDetails() {
      this.detailsExpanded = !this.detailsExpanded;
    }
    static {
      this.ɵfac = function PromoCodeCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PromoCodeCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromoCodeCardComponent,
        selectors: [["fly-promo-code-card"]],
        inputs: {
          name: "name",
          duration: "duration",
          expiry: "expiry",
          devices: "devices",
          redeemed: "redeemed",
          uuid: "uuid",
          selected: "selected",
          choices: "choices",
          detailsHTML: "detailsHTML",
          supportedPlatforms: "supportedPlatforms"
        },
        outputs: {
          makeChoice: "makeChoice",
          manageDevices: "manageDevices"
        },
        decls: 8,
        vars: 7,
        consts: [[1, "promo-name"], [1, "promo-detail"], [1, "promo-detail", "card-buttons"], [1, "selection-button-container"], [1, "promo-expiry-title"], [3, "click", "flat"], [1, "details-button"], ["icon", "chevron-up", 1, "icon", "size-small", "color-black"], ["icon", "chevron-down", 1, "icon", "size-small", "color-black"], [3, "detailsHTML", "supportedPlatforms"], [1, "strong"], ["theme", "black"], ["theme", "black", 3, "click"]],
        template: function PromoCodeCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtext(1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, PromoCodeCardComponent_Conditional_2_Template, 2, 1, "div", 1)(3, PromoCodeCardComponent_Conditional_3_Template, 5, 3, "div", 1)(4, PromoCodeCardComponent_Conditional_4_Template, 7, 5, "div", 1);
            i0.ɵɵelementStart(5, "div", 2);
            i0.ɵɵtemplate(6, PromoCodeCardComponent_Conditional_6_Template, 1, 0, "div")(7, PromoCodeCardComponent_Conditional_7_Template, 4, 3, "div", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate2("", ctx.name, " \u2014 ", ctx.duration, "");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.devices > 1 ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.expiryCalc != null ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.redeemed && (ctx.detailsHTML != null || ctx.supportedPlatforms != null) ? 4 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.redeemed ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.redeemed ? 7 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, FormattedDatePipe, IconComponent, CoverageDetailsMobileDeviceComponent, RouterModule],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:block;padding:1.5rem;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;gap:2rem}.promo-name[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:700}.promo-detail[_ngcontent-%COMP%]{font-size:.75rem}.promo-detail[_ngcontent-%COMP%]:not(:last-child){margin-bottom:1rem}.promo-expiry-title[_ngcontent-%COMP%]{font-weight:700}@media screen and (min-width: 768px){.promo-expiry-title[_ngcontent-%COMP%]{font-weight:400}}.card-buttons[_ngcontent-%COMP%]{display:flex;align-items:flex-end;justify-content:space-between}.strong[_ngcontent-%COMP%]{font-weight:700}.selection-button-container[_ngcontent-%COMP%]{width:100%}@media screen and (min-width: 768px){.selection-button-container[_ngcontent-%COMP%]{width:auto;text-align:right;margin-left:auto}}.button[_ngcontent-%COMP%]{margin:1rem 0 0}@media screen and (min-width: 768px){.button[_ngcontent-%COMP%]{margin:0}}.details-button[_ngcontent-%COMP%]{display:flex;align-items:center;gap:.5rem}"]
      });
    }
  }
  return PromoCodeCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PromoCodeChoiceCardComponent = /*#__PURE__*/(() => {
  class PromoCodeChoiceCardComponent {
    constructor() {
      this.selected = new EventEmitter();
      this.expiryCalc = null;
      this.slotDetails = null;
    }
    ngOnInit() {
      this.newSubscription = this.subscription == null || this.subscription.subscriptionUuid == null || this.subscription.subscriptionUuid === '';
      if (this.duration != null && this.duration != '') {
        const durationSplit = this.duration.split(' ');
        if (durationSplit.length === 2) {
          const num = parseInt(durationSplit[0]);
          if (!isNaN(num)) {
            const unit = durationSplit[1].toLocaleLowerCase();
            if (unit.startsWith('month')) {
              this.expiryCalc = this.newSubscription ? new Date() : new Date(this.subscription.authorization.activeEndDate);
              this.expiryCalc.setMonth(this.expiryCalc.getMonth() + num);
            } else if (unit.startsWith('year')) {
              this.expiryCalc = this.newSubscription ? new Date() : new Date(this.subscription.authorization.activeEndDate);
              this.expiryCalc.setFullYear(this.expiryCalc.getFullYear() + num);
            }
          }
        }
      }
      if (this.subscription?.gpSubscriptions?.slotDetails != null) {
        this.slotDetails = this.subscription.gpSubscriptions.slotDetails;
      }
    }
    makeSelection() {
      this.selected.emit(this.newSubscription ? null : this.subscription);
    }
    static {
      this.ɵfac = function PromoCodeChoiceCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PromoCodeChoiceCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromoCodeChoiceCardComponent,
        selectors: [["fly-promo-code-choice-card"]],
        inputs: {
          duration: "duration",
          subscription: "subscription",
          existing: "existing"
        },
        outputs: {
          selected: "selected"
        },
        decls: 10,
        vars: 6,
        consts: [[1, "promo-name"], [1, "promo-detail"], [1, "promo-detail", "selection-button-container"], [1, "strong"], ["theme", "dark", 3, "click"], [1, "promo-expiry-title"]],
        template: function PromoCodeChoiceCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "div", 0);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, PromoCodeChoiceCardComponent_Conditional_3_Template, 2, 2)(4, PromoCodeChoiceCardComponent_Conditional_4_Template, 7, 4, "div", 1)(5, PromoCodeChoiceCardComponent_Conditional_5_Template, 5, 3, "div", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 2);
            i0.ɵɵtemplate(7, PromoCodeChoiceCardComponent_Conditional_7_Template, 2, 0, "div", 3);
            i0.ɵɵelementStart(8, "g-button", 4);
            i0.ɵɵlistener("click", function PromoCodeChoiceCardComponent_Template_g_button_click_8_listener() {
              return ctx.makeSelection();
            });
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.newSubscription ? "Start a New Subscription" : "Extend Existing Subscription");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.slotDetails != null ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.newSubscription ? 4 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.newSubscription && ctx.expiryCalc != null ? 5 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.existing ? 7 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.newSubscription ? "Start Subscription" : "Extend", " ");
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, FormattedDatePipe],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;padding:1.5rem;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;align-items:flex-end;justify-content:space-between;flex-direction:column;gap:1rem}@media screen and (min-width: 768px){[_nghost-%COMP%]{flex-direction:row}}.promo-name[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:700}.promo-detail[_ngcontent-%COMP%]{font-size:.75rem}.promo-detail[_ngcontent-%COMP%]:not(:last-child){margin-bottom:1rem}.promo-expiry-title[_ngcontent-%COMP%]{font-weight:700}@media screen and (min-width: 768px){.promo-expiry-title[_ngcontent-%COMP%]{font-weight:400}}.strong[_ngcontent-%COMP%]{font-weight:700}.selection-button-container[_ngcontent-%COMP%]{text-align:left;width:100%}@media screen and (min-width: 768px){.selection-button-container[_ngcontent-%COMP%]{text-align:right;width:auto}}"]
      });
    }
  }
  return PromoCodeChoiceCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var State$2 = /*#__PURE__*/function (State) {
  State[State["EMPTY"] = 0] = "EMPTY";
  State[State["LOADING"] = 1] = "LOADING";
  State[State["LOADED"] = 2] = "LOADED";
  return State;
}(State$2 || {});
let PromoCodeSubscriptionsListComponent = /*#__PURE__*/(() => {
  class PromoCodeSubscriptionsListComponent {
    constructor() {
      this.redeemed = false;
      this.manageDevices = new EventEmitter();
      this.userSelection = new EventEmitter();
      this.editing = new EventEmitter();
      this.State = State$2;
      this.promoCodeSkuProducts = [];
      this.selectedChoicesUuid = new Map();
      this.currentState = State$2.LOADING;
      this.currentlySelectingProduct = null;
      this.currentlySelectingSubscription = null;
      this.currentlySelectingExisting = null;
      this.skuService = inject(SKU_SERVICE_TOKEN);
      this.destroyRef = inject(DestroyRef);
    }
    ngOnInit() {
      if (this.promoCodeData?.skus == null || this.promoCodeData.skus.length === 0) {
        this.currentState = State$2.EMPTY;
        return;
      }
      this.skuService.getSkuProducts(this.promoCodeData.skus).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        this.promoCodeSkuProducts = data;
        this.checkExistingSubscriptions();
        this.currentState = State$2.LOADED;
      });
    }
    checkExistingSubscriptions() {
      this.skuToChoices = this.promoCodeSkuProducts.reduce((skuMap, {
        sku
      }) => {
        // Quick and dirty solution to find the "root SKU".
        const rootSku = sku.match(/(GP-(?:ADD|SUB)-[A-Z]+)(?:\d+YR?|\d+M)((?:-[A-Z]+)+)/)?.slice(1).join('');
        // We need to find all activeSubscriptions that use the root SKU.
        const skuArray = this.activeSubscriptions.filter(gpSub => gpSub.key === rootSku);
        skuMap.set(sku, skuArray);
        if (skuArray.length === 0) {
          this.selectedChoicesUuid.set(sku, '');
        }
        return skuMap;
      }, new Map());
      this.checkAllChosen();
    }
    makeChoice(product) {
      const subscriptions = this.skuToChoices.get(product.sku);
      if (subscriptions != null && subscriptions.length > 0) {
        this.editing.emit(true);
        this.currentlySelectingProduct = product;
        this.currentlySelectingSubscription = subscriptions;
        const existing = this.selectedChoicesUuid.get(product.sku);
        if (existing != null) {
          this.currentlySelectingExisting = existing;
        }
      } else if (subscriptions?.length === 0) {
        // You shouldn't be able to trigger this, but just in case...
        this.makeSelection(product, null);
      }
    }
    makeSelection(product, selection) {
      this.selectedChoicesUuid.set(product.sku, selection?.subscriptionUuid ?? '');
      this.clearChoosing();
      this.checkAllChosen();
    }
    clearChoosing() {
      this.editing.emit(false);
      this.currentlySelectingProduct = null;
      this.currentlySelectingSubscription = null;
      this.currentlySelectingExisting = null;
    }
    checkAllChosen() {
      let allChosen = true;
      this.skuToChoices.forEach((_gpSub, sku) => {
        if (this.selectedChoicesUuid.get(sku) == null) {
          allChosen = false;
        }
      });
      if (allChosen) {
        const finalSkus = [];
        this.selectedChoicesUuid.forEach((choice, sku) => {
          finalSkus.push({
            sku,
            subscriptionUuid: choice !== '' ? choice : undefined
          });
        });
        this.userSelection.emit(finalSkus);
      }
    }
    static {
      this.ɵfac = function PromoCodeSubscriptionsListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PromoCodeSubscriptionsListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromoCodeSubscriptionsListComponent,
        selectors: [["fly-promo-code-subscriptions-list"]],
        inputs: {
          promoCodeData: "promoCodeData",
          activeSubscriptions: "activeSubscriptions",
          redeemed: "redeemed"
        },
        outputs: {
          manageDevices: "manageDevices",
          userSelection: "userSelection",
          editing: "editing"
        },
        decls: 5,
        vars: 5,
        consts: [["type", "dark", 1, "loader"], [3, "name", "duration", "redeemed", "uuid", "selected", "choices", "detailsHTML", "supportedPlatforms"], [3, "makeChoice", "manageDevices", "name", "duration", "redeemed", "uuid", "selected", "choices", "detailsHTML", "supportedPlatforms"], [1, "promo-name"], [3, "selected", "duration", "existing"], [3, "duration", "subscription", "existing"], ["theme", "white", 3, "click"], [3, "selected", "duration", "subscription", "existing"]],
        template: function PromoCodeSubscriptionsListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PromoCodeSubscriptionsListComponent_Conditional_0_Template, 1, 0, "g-loader", 0)(1, PromoCodeSubscriptionsListComponent_Conditional_1_Template, 2, 0, "h2")(2, PromoCodeSubscriptionsListComponent_Conditional_2_Template, 2, 0, "h2")(3, PromoCodeSubscriptionsListComponent_Conditional_3_Template, 2, 0)(4, PromoCodeSubscriptionsListComponent_Conditional_4_Template, 8, 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.currentState === ctx.State.LOADING ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentState === ctx.State.LOADED && ctx.promoCodeSkuProducts.length === 0 ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentState === ctx.State.EMPTY ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentlySelectingSubscription == null ? 3 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentlySelectingSubscription != null && ctx.currentlySelectingProduct != null ? 4 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GLoader, PromoCodeCardComponent, PromoCodeChoiceCardComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}.promo-name[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:700}"]
      });
    }
  }
  return PromoCodeSubscriptionsListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var State$1 = /*#__PURE__*/function (State) {
  State[State["ENTER"] = 0] = "ENTER";
  State[State["SELECT"] = 1] = "SELECT";
  State[State["OVERVIEW"] = 2] = "OVERVIEW";
  return State;
}(State$1 || {});
let PromoCodeWizardComponent = /*#__PURE__*/(() => {
  class PromoCodeWizardComponent {
    constructor() {
      this.manageDevices = new EventEmitter();
      this.config = inject(FLY_WEB_COMMON_CONFIG);
      this.State = State$1;
      this.currentState = State$1.ENTER;
      this.loading = false;
      this.redeemed = false;
      this.editing = false;
      this.promoResponseError = '';
      this.promoCodeSubsets = [];
      this.showReasonInputTextBox = this.config.site === 'FALA';
      this.activatedRoute = inject(ActivatedRoute);
      this.router = inject(Router);
      this.subscriptionsService = inject(SUBSCRIPTIONS_SERVICE_TOKEN);
      this.garminPilotSubscriptionService = inject(GarminPilotSubscriptionsService);
      this.jobManagementService = inject(SUBSCRIPTIONS_JOB_MANAGEMENT_TOKEN, {
        optional: true
      });
      this.featuresService = inject(FeaturesService);
      this.destroyRef = inject(DestroyRef);
    }
    ngOnInit() {
      this.promoCodeInput = new FormControl();
      this.promoCodeRadio = new FormControl();
      this.reasonInput = new FormControl();
      this.existingSubscriptions = [];
      this.subscriptionsService.getGarminPilotSubscriptions().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: subs => {
          this.existingSubscriptions = subs;
        },
        error: err => {
          console.error('There was an error fetching your existing subscriptions: ', err);
        }
      });
    }
    checkPromoCode() {
      if (this.promoCodeInput.invalid || this.loading) {
        return;
      }
      this.promoResponseError = '';
      this.promoCodeSubsets = [];
      this.loading = true;
      this.getPromoCode(this.promoCodeInput.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: response => {
          if (response.errors == null || response.errors.length === 0) {
            this.promoCodeResponse = response.data;
            this.promoCodeSubsets = response.data.subsets;
            if (this.promoCodeSubsets.length === 0) {
              this.promoResponseError = 'No data for that coupon.';
            } else if (this.promoCodeSubsets.length > 1) {
              this.currentState = State$1.SELECT;
            } else {
              this.promoCodeSelection = this.promoCodeSubsets[0];
              this.currentState = State$1.OVERVIEW;
            }
            return;
          }
          this.promoResponseError = response.errors.map(({
            message
          }) => message).join('<br>');
        },
        error: error => {
          if (typeof error === 'string') {
            this.promoResponseError = error;
          } else if (error.message != null) {
            this.promoResponseError = error.message;
          } else {
            this.promoResponseError = 'An error occurred';
          }
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
    getPromoCode(promoCode) {
      return this.featuresService.isFeatureActive(FeatureFlyGarmin.YARMOUTH_API_GET_COUPON_V2).pipe(switchMap(enabled => enabled ? this.garminPilotSubscriptionService.getPromoCodeV2(promoCode) : this.garminPilotSubscriptionService.getPromoCode(promoCode).pipe(map(response => ({
        ...response,
        data: {
          marketingCampaign: null,
          subsets: response.data
        }
      })))));
    }
    resetToEnter() {
      this.reasonInput.reset();
      this.promoResponseError = '';
      this.promoCodeResponse = null;
      this.promoCodeSubsets = [];
      this.promoCodeSelection = null;
      this.promoCodeRadio.reset();
      this.usersSelections = undefined;
      this.currentState = State$1.ENTER;
    }
    resetToSelect() {
      this.promoCodeSelection = null;
      this.usersSelections = undefined;
      this.currentState = State$1.SELECT;
    }
    selectPromoCode() {
      this.promoCodeSelection = this.promoCodeRadio.value;
      this.currentState = State$1.OVERVIEW;
    }
    fullSelection(selections) {
      this.usersSelections = selections;
    }
    editingMode(mode) {
      this.editing = mode;
    }
    redeemPromoCode() {
      if (this.promoCodeSelection == null) {
        return;
      }
      this.loading = true;
      const promoCodeRedeemPayload = {
        couponCode: this.promoCodeInput.value,
        subsetId: this.promoCodeSelection.subsetId,
        skus: this.promoCodeSelection.skus.map(sku => {
          return {
            sku,
            subscriptionUuid: this.usersSelections?.find(selection => selection.sku === sku)?.subscriptionUuid
          };
        }),
        marketingCampaign: this.promoCodeResponse?.marketingCampaign ?? null,
        memo: this.reasonInput.value ?? null
      };
      this.garminPilotSubscriptionService.redeemPromoCode(promoCodeRedeemPayload, this.customerGuid).pipe(concatMap(response => {
        const jobsToCreate = [];
        if (this.jobManagementService != null && this.jobManagementService.createPendingSubscriptionJob != null) {
          for (const skuInfo of promoCodeRedeemPayload.skus) {
            jobsToCreate.push(this.jobManagementService.createPendingSubscriptionJob({
              statusJobUuid: response.jobUuid,
              sku: skuInfo.sku,
              subscriptionUuid: skuInfo.subscriptionUuid,
              customerGuid: promoCodeRedeemPayload.customerGuid ?? this.customerGuid,
              subscriptionJobType: {
                uuid: '',
                name: 'pilot'
              },
              subscriptionActionType: {
                uuid: '',
                name: skuInfo.subscriptionUuid != null ? 'extend' : 'redeem'
              }
            }));
          }
        }
        return forkJoin({
          response: of(response),
          createdJobs: jobsToCreate.length === 0 ? of([]) : forkJoin(jobsToCreate)
        });
      }), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: ({
          response
        }) => {
          if (response.errors == null || response.errors.length === 0) {
            this.redeemed = true;
            return;
          }
          this.promoResponseError = response.errors.map(({
            message
          }) => message).join('<br>');
        },
        error: error => {
          if (typeof error === 'string') {
            this.promoResponseError = error;
          } else if (error.message != null) {
            this.promoResponseError = error.message;
          } else {
            this.promoResponseError = 'An error occurred';
          }
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
    navigateToActiveSubscriptions() {
      this.router.navigate(['../'], {
        relativeTo: this.activatedRoute,
        replaceUrl: true
      });
    }
    static {
      this.ɵfac = function PromoCodeWizardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PromoCodeWizardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PromoCodeWizardComponent,
        selectors: [["fly-promo-code-wizard"]],
        inputs: {
          customerGuid: "customerGuid"
        },
        outputs: {
          manageDevices: "manageDevices"
        },
        decls: 4,
        vars: 4,
        consts: [["type", "dark", 1, "loader"], [1, "input-wrapper"], ["label", "Promo Code", "label-for", "promoCode", "required", "true"], ["id", "promoCode", "required", "", "type", "text", 3, "formControl"], [1, "redeem-button-container"], ["theme", "black", "size", "large", 3, "click", "disabled"], [3, "innerHTML"], [1, "strong"], [1, "subset-selection"], [3, "label"], [1, "button-container"], ["theme", "white", 3, "click"], ["theme", "black", 3, "click", "disabled"], ["name", "regionSelect", "type", "radio", 3, "formControl", "value"], [1, "ribbon"], [3, "editing", "userSelection", "promoCodeData", "activeSubscriptions", "redeemed"], ["label", "Reason", "label-for", "reason", "required", "true"], [1, "button-container", "full-width"], ["theme", "white", 3, "disabled"], ["id", "reason", "required", "", "type", "text", 3, "formControl"], ["theme", "white", 3, "click", "disabled"], ["theme", "black", 3, "click"]],
        template: function PromoCodeWizardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, PromoCodeWizardComponent_Conditional_0_Template, 8, 4)(1, PromoCodeWizardComponent_Conditional_1_Template, 10, 1)(2, PromoCodeWizardComponent_Conditional_2_Template, 5, 7)(3, PromoCodeWizardComponent_Conditional_3_Template, 1, 0, "g-loader", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.currentState === ctx.State.ENTER ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentState === ctx.State.SELECT ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.currentState === ctx.State.OVERVIEW && ctx.promoCodeSelection != null ? 2 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.loading ? 3 : -1);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GError, i1.GInput, i1.GLoader, i1.GRadio, ReactiveFormsModule, i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.RequiredValidator, i2$1.FormControlDirective, PromoCodeSubscriptionsListComponent],
        styles: [".icon.size-small[_ngcontent-%COMP%]{width:.875rem;height:.875rem}.icon.size-standard[_ngcontent-%COMP%]{width:1.125rem;height:1.125rem}.icon.size-large[_ngcontent-%COMP%]{width:1.75rem;height:1.75rem}.icon.color-black[_ngcontent-%COMP%]{color:#000}.icon.color-red[_ngcontent-%COMP%]{color:#920000}.icon.color-green[_ngcontent-%COMP%]{color:#4bb450}.icon.color-yellow[_ngcontent-%COMP%]{color:#ffaf33}.icon.color-garmin-blue[_ngcontent-%COMP%]{color:#106fad}.icon.color-dark-gray[_ngcontent-%COMP%]{color:#737373}.icon.effect-hover[_ngcontent-%COMP%]{opacity:0;transition:opacity .2s}.icon.effect-hover[_ngcontent-%COMP%]:hover, .icon.effect-hover[_ngcontent-%COMP%]:focus-visible{opacity:1}.icon.prop-clickable[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]{display:flex;flex-direction:column;gap:1rem}.main-title[_ngcontent-%COMP%]{text-transform:uppercase}.strong[_ngcontent-%COMP%]{font-weight:700}.input-wrapper[_ngcontent-%COMP%]{max-width:350px;display:flex;flex-direction:row;margin-bottom:2rem}.subset-selection[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:0}.button-container[_ngcontent-%COMP%]{display:flex;gap:1rem}.button-container.full-width[_ngcontent-%COMP%]{justify-content:space-between}.ribbon[_ngcontent-%COMP%]{text-transform:uppercase;background-color:#6dcff6;padding:1rem}.redeem-button-container[_ngcontent-%COMP%]{margin-top:1.65rem;padding-left:1.5rem}"]
      });
    }
  }
  return PromoCodeWizardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DevicePlatformPipe = /*#__PURE__*/(() => {
  class DevicePlatformPipe {
    transform(device) {
      switch (device.gpDevicePlatform?.toUpperCase()) {
        case 'IOS':
          return 'iOS';
        case 'ANDROID':
          return 'Android';
        default:
          return 'Other';
      }
    }
    static {
      this.ɵfac = function DevicePlatformPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DevicePlatformPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyDevicePlatform",
        type: DevicePlatformPipe,
        pure: true
      });
    }
  }
  return DevicePlatformPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GpSubscriptionTypePipe = /*#__PURE__*/(() => {
  class GpSubscriptionTypePipe {
    transform(value) {
      const sku = typeof value === 'string' ? value.toUpperCase() : value.key.toUpperCase();
      if (sku.includes('SUB')) {
        return 'BASE';
      }
      if (sku.includes('ADD')) {
        return 'ADD-ON';
      }
      return 'UNKNOWN';
    }
    static {
      this.ɵfac = function GpSubscriptionTypePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GpSubscriptionTypePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyGpSubscriptionType",
        type: GpSubscriptionTypePipe,
        pure: true
      });
    }
  }
  return GpSubscriptionTypePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AddMobileDeviceToSlotCardComponent = /*#__PURE__*/(() => {
  class AddMobileDeviceToSlotCardComponent {
    constructor() {
      this.deviceAdded = new EventEmitter();
      this.initializationError = false;
      this.spotClaimingError = false;
      this.selectedDeviceUuid = null;
      this.devices = [];
      this.destroyRef = inject(DestroyRef);
      this.garminPilotDeviceRegistrationService = inject(GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN);
      this.subscriptionsService = inject(SUBSCRIPTIONS_SERVICE_TOKEN);
      this.mobileDeviceService = inject(MOBILE_DEVICE_SERVICE_TOKEN, {
        optional: true
      });
      this.filterOutDevicesAlreadyClaimedOnSubscription = gpDeviceRegistrations => combineLatest(gpDeviceRegistrations.map(device => this.subscriptionsService.getSubscriptionsByGpDeviceCode(device.gpDeviceCode).pipe(map(gpSubscriptions => ({
        device,
        gpSubscriptions
      }))))).pipe(map(response => response.filter(deviceGpSubscriptions => !deviceGpSubscriptions.gpSubscriptions.map(sub => sub.key).includes(this.subscription.key)).map(result => result.device)));
      this.filterOutDevicesWithoutBaseSubscription = userOwnedDevices => this.subscriptionsService.getGarminPilotSubscriptions().pipe(take(1), map(subscriptions => {
        const devicesWithBaseSubscription = new Set();
        subscriptions.forEach(subscription => subscription.gpSubscriptions?.slotDetails.claimedSlotDevices?.forEach(claimedSlotDevice => devicesWithBaseSubscription.add(claimedSlotDevice)));
        return userOwnedDevices.filter(device => devicesWithBaseSubscription.has(device.gpDeviceCode));
      }));
    }
    ngOnInit() {
      this.garminPilotDeviceRegistrationService.getAllDeviceRegistrationsForCustomer().pipe(take(1), switchMap(this.filterOutDevicesAlreadyClaimedOnSubscription), concatMap(devices => iif(() => this.subscription.key.toUpperCase().includes('ADD'), this.filterOutDevicesWithoutBaseSubscription(devices), of(devices)))).subscribe({
        next: devices => this.devices = devices,
        error: e => {
          console.error(e);
          this.initializationError = true;
        }
      });
    }
    addDeviceToSlot() {
      if (this.selectedDeviceUuid == null) {
        //Should never be hit
        throw new Error('addDeviceToSlot was called prior to selectedDeviceUuid being set');
      }
      this.subscriptionsService.claimSubscriptionDeviceSlot(this.subscription.subscriptionUuid, {
        deviceRegistrationUuid: this.selectedDeviceUuid
      }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: () => {
          this.spotClaimingError = false;
          this.deviceAdded.emit();
          this.mobileDeviceService?.updateMobileDeviceStatus(true);
        },
        error: e => {
          console.error(e);
          this.spotClaimingError = true;
        }
      });
    }
    static {
      this.ɵfac = function AddMobileDeviceToSlotCardComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AddMobileDeviceToSlotCardComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AddMobileDeviceToSlotCardComponent,
        selectors: [["fly-add-mobile-device-to-slot-card"]],
        inputs: {
          subscription: "subscription"
        },
        outputs: {
          deviceAdded: "deviceAdded"
        },
        decls: 3,
        vars: 1,
        consts: [[1, "card-container"], [1, "error"], ["label", "Add Mobile Device to Subscription", 1, "drop-down-wrapper"], ["required", "", "aria-describedby", "spotClaimingError", 3, "ngModelChange", "ngModel"], [3, "value"], ["id", "spotClaimingError"], [1, "button", 3, "click", "disabled"]],
        template: function AddMobileDeviceToSlotCardComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AddMobileDeviceToSlotCardComponent_Conditional_1_Template, 2, 1)(2, AddMobileDeviceToSlotCardComponent_Conditional_2_Template, 2, 0, "p", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.initializationError ? 1 : 2);
          }
        },
        dependencies: [CommonModule, ComponentsGlobalWebModule, i1.GButton, i1.GDropDown, i1.GError, FormsModule, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.SelectControlValueAccessor, i2$1.NgControlStatus, i2$1.RequiredValidator, i2$1.NgModel, GpSubscriptionTypePipe],
        styles: [".card-container[_ngcontent-%COMP%]{padding:1.5rem;box-shadow:0 1px 1px #4d4d4d14,0 1px 3px 1px #4d4d4d29;gap:2rem}@media screen and (min-width: 1024px){.card-container[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}}.error[_ngcontent-%COMP%]{color:#920000}.button[_ngcontent-%COMP%]{margin-top:1rem}.drop-down-wrapper[_ngcontent-%COMP%]{font-size:1.5rem;font-weight:700}.drop-down-wrapper[_ngcontent-%COMP%]   select[_ngcontent-%COMP%]{font-size:initial;font-weight:initial}"]
      });
    }
  }
  return AddMobileDeviceToSlotCardComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var State = /*#__PURE__*/function (State) {
  State[State["Loading"] = 0] = "Loading";
  State[State["ErrorNoSubscriptionUuid"] = 1] = "ErrorNoSubscriptionUuid";
  State[State["ErrorSubscriptionDetails"] = 2] = "ErrorSubscriptionDetails";
  State[State["Loaded"] = 3] = "Loaded";
  return State;
}(State || {});
let SlotManagementPageComponent = /*#__PURE__*/(() => {
  class SlotManagementPageComponent {
    constructor() {
      this.refreshSignal$ = new BehaviorSubject(undefined);
      this.State = State;
      this.currentState = State.Loading;
      this.siteConfig = inject(FLY_WEB_COMMON_CONFIG);
      this.location = inject(Location);
      this.activatedRoute = inject(ActivatedRoute);
      this.destroyRef = inject(DestroyRef);
      this.deviceRegistrationService = inject(GARMIN_PILOT_DEVICE_REGISTRATIONS_SERVICE_TOKEN);
      this.scopeService = inject(ScopeService);
      this.subscriptionsService = inject(SUBSCRIPTIONS_SERVICE_TOKEN);
      this.mobileDeviceService = inject(MOBILE_DEVICE_SERVICE_TOKEN, {
        optional: true
      });
      this.getSubscriptionUuidFromRoute = () => this.activatedRoute.params.pipe(filter(params => {
        if (params['subscriptionUuid'] == null || typeof params['subscriptionUuid'] !== 'string') {
          this.currentState = State.ErrorNoSubscriptionUuid;
          return false;
        }
        return true;
      }), map(params => params['subscriptionUuid']));
      this.getSubscriptionsByUuid = subscriptionUuid => this.subscriptionsService.getSubscriptionByUuid(subscriptionUuid).pipe(skipWhile(subscription => this.subscription === subscription), take(1), tap(subscription => this.subscription = subscription));
      this.getDevicesBySubscription = subscription => {
        if (subscription.gpSubscriptions == null) {
          throw Error('subscription.gpSubscriptions returned null unexpectedly.');
        }
        const requests$ = subscription.gpSubscriptions.slotDetails.claimedSlotDevices?.map(gpDeviceCode => this.deviceRegistrationService.getDeviceRegistrationByGpDeviceCode(gpDeviceCode).pipe(take(1)));
        return requests$ == null ? of([]) : forkJoin(requests$);
      };
    }
    ngOnInit() {
      this.canClaimSlot$ = this.scopeService.determinePrivilege(Scope.GP_SUBSCRIPTION_DEVICE_SLOT_CLAIM);
      this.getSubscriptionUuidFromRoute().pipe(combineLatestWith(this.refreshSignal$), tap(() => {
        this.currentState = State.Loading;
      }), switchMap(([subscriptionUuid]) => this.getSubscriptionsByUuid(subscriptionUuid)), concatMap(this.getDevicesBySubscription), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: deviceRegistrations => {
          this.deviceRegistrations = deviceRegistrations;
          this.currentState = State.Loaded;
        },
        error: e => {
          console.error(e);
          this.currentState = State.ErrorSubscriptionDetails;
        }
      });
    }
    handleRemoveActionClicked(device) {
      const removeRequest$ = subscriptionUuid => {
        if (device.uuid == null) {
          //Should never be hit.
          throw new Error('deviceRegistrationUuid is unexpectedly null.');
        }
        return this.subscriptionsService.removeDeviceFromSubscriptionSlot(subscriptionUuid, device.uuid);
      };
      const finalRequest$ = removeRequest$(this.subscription.subscriptionUuid);
      //If a DEMO or ADD ON (wont include sub) then just remove device from slot.
      //If it is a base subscription, then check if this device has another base subscription.
      //...If there is another base subscription, then we are good to remove device from slot.
      //...If there is no other base subscriptions, then remove all other ADD-ONs if necessary.
      const request$ = !this.subscription.key.toUpperCase().includes('SUB') ? finalRequest$ : this.subscriptionsService.getSubscriptionsByGpDeviceCode(device.gpDeviceCode).pipe(take(1), concatMap(subscriptions => {
        const deleteRequests$ = [];
        for (const subscription of subscriptions) {
          if (subscription.subscriptionUuid !== this.subscription.subscriptionUuid) {
            if (subscription.key.toUpperCase().includes('SUB')) {
              return of([]);
            }
            if (subscription.key.toUpperCase().includes('ADD')) {
              deleteRequests$.push(removeRequest$(subscription.subscriptionUuid));
            }
          }
        }
        return deleteRequests$.length > 0 ? forkJoin(deleteRequests$) : of([]);
      }), concatMap(() => finalRequest$));
      request$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        complete: () => {
          this.refreshSignal$.next();
          if (this.mobileDeviceService != null) {
            this.mobileDeviceService.updateMobileDeviceStatus(true);
          }
        },
        error: () => {
          this.currentState = State.ErrorSubscriptionDetails;
        }
      });
    }
    static {
      this.ɵfac = function SlotManagementPageComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SlotManagementPageComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SlotManagementPageComponent,
        selectors: [["fly-slot-management-page"]],
        decls: 6,
        vars: 1,
        consts: [["type", "button", "role", "button", 1, "back-button", 3, "click"], [1, "error"], [1, "mobile-devices-header"], ["action", "remove", 1, "card", 3, "name", "site", "uniqueId", "devicePlatform"], ["action", "remove", 1, "card", 3, "actionClicked", "name", "site", "uniqueId", "devicePlatform"], [3, "subscription"], [3, "deviceAdded", "subscription"]],
        template: function SlotManagementPageComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function SlotManagementPageComponent_Template_button_click_0_listener() {
              return ctx.location.back();
            });
            i0.ɵɵtext(1, " \uD83E\uDC14 Back to Previous Page\n");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, SlotManagementPageComponent_Case_2_Template, 1, 0, "g-loader")(3, SlotManagementPageComponent_Case_3_Template, 2, 0, "p", 1)(4, SlotManagementPageComponent_Case_4_Template, 2, 0, "p", 1)(5, SlotManagementPageComponent_Case_5_Template, 17, 11);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_0_0 = ctx.currentState) === ctx.State.Loading ? 2 : tmp_0_0 === ctx.State.ErrorNoSubscriptionUuid ? 3 : tmp_0_0 === ctx.State.ErrorSubscriptionDetails ? 4 : tmp_0_0 === ctx.State.Loaded ? 5 : -1);
          }
        },
        dependencies: [AddMobileDeviceToSlotCardComponent, CommonModule, i2.AsyncPipe, ComponentsGlobalWebModule, i1.GLoader, MobileDeviceCardComponent, DevicePlatformPipe, FormattedDatePipe],
        styles: [".back-button[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:1rem;text-decoration:underline;cursor:pointer;background:none;border:none}.error[_ngcontent-%COMP%]{color:#920000}h2[_ngcontent-%COMP%]{margin:1rem 0;font-weight:700}h3[_ngcontent-%COMP%]{font-size:2.5rem;margin:0}.mobile-devices-header[_ngcontent-%COMP%]{border-bottom:1px solid #000;display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;margin:1rem 0;padding-bottom:.5rem;column-gap:1.5rem}.mobile-devices-header[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{width:max-content}.card[_ngcontent-%COMP%]{margin-bottom:1.25rem;display:block}"]
      });
    }
  }
  return SlotManagementPageComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IsGarminPilotSubscriptionPipe = /*#__PURE__*/(() => {
  class IsGarminPilotSubscriptionPipe {
    transform(value) {
      return isGarminPilotSubscription(value);
    }
    static {
      this.ɵfac = function IsGarminPilotSubscriptionPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || IsGarminPilotSubscriptionPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyIsGarminPilotSubscription",
        type: IsGarminPilotSubscriptionPipe,
        pure: true
      });
    }
  }
  return IsGarminPilotSubscriptionPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CoverageDetailsMobileDeviceComponent, DevicePlatformPipe, IsGarminPilotSubscriptionPipe, ManageMobileDeviceComponent, MobileDeviceCardComponent, PromoCodeCardComponent, PromoCodeChoiceCardComponent, PromoCodeSubscriptionsListComponent, PromoCodeWizardComponent, SlotManagementPageComponent };
